// eslint-disable-next-line import/no-internal-modules
import { zodResolver } from '@hookform/resolvers/zod';
import type { DefaultValues, FieldValues, Mode } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import type { z } from 'zod';
import type { ServerError } from './useServerErrorToFormError';
import { useServerErrorToFormError } from './useServerErrorToFormError';

export type UseEnhancedFormProps<TFormValues> = {
  context?: object;
  initialValues?: DeepNullablePartial<TFormValues>;
  mode?: Mode;
  schema?: z.AnyZodObject | z.ZodEffects<any> | z.ZodUnion<any>;
  serverError?: ServerError | undefined | null;
};

export const useEnhancedForm = <T extends FieldValues>({ context, initialValues, mode = 'onBlur', schema, serverError }: UseEnhancedFormProps<T>) => {
  const methods = useForm<T>({
    context,
    // This allows us to support nulls as well as undefined, which we need for dates
    defaultValues: initialValues as unknown as DefaultValues<T>,
    mode,
    resolver: schema ? zodResolver(schema) : undefined,
  });

  useServerErrorToFormError({ serverError, setError: methods.setError });

  return methods;
};
